import React, { Component } from 'react';
import { Container, Row, Col, Card, Alert, Button } from 'react-bootstrap';
import { Helmet } from "react-helmet";
import { useNavigate, useParams } from "react-router-dom";
import { Link } from 'react-router-dom';
import DBService from '../../service/DBService';

class ConfirmUserIdWithParams extends Component {
  constructor(props) {
    super(props);
    this.state = {
      props: this.props,
      navigate: this.props.navigate,
      result: '',
      error: '',
      resendResult: '',
      resendError: ''
    };
    console.log('ConfirmUserIdWithParams ', this.props);
  }

  componentDidMount() {
    if (this.state.props !== undefined && Object.keys(this.state.props).length > 0) {
      let body = {
        'userId': this.state.props.emailId,
        'hashPassword': this.state.props.hashPassword
      }
      console.log('userId, hashPassword', body);
      DBService.userConfirmUserid(body)
        .then(result => {
          result = result.data;
          console.log('Updated', result);
          if (result !== undefined && result.length !== undefined && result.length > 0) {
            this.setState({ 'result': result, error: '' })
          } else {
            this.setState({ 'result': '', 'error': 'Error Email Confirmation ' })
          }
        })
        .catch((error) => {
          console.log(error);
          this.setState({ 'result': '',  'error': 'Error Signing in with EmailId, please try again' });
        });
    }
  }

  resendEmailConfirmation = () => {
    if (this.state.props !== undefined && Object.keys(this.state.props).length > 0) {
      this.setState({'result': '', error: ''});
      let body = {
        'userId': this.state.props.emailId,
        'hashPassword': this.state.props.hashPassword
      }
      DBService.userVerifyUserid(body)
        .then(result => {
          result = result.data;
          console.log('Updated', result);
          if (result !== undefined && result.length !== undefined && result.length > 0) {
            this.setState({ 'resendResult': result, 'resendError': '' });
          } else {
            this.setState({ 'resendResult': '', 'resendError': 'UserId not found please signup again ' });
          }
        })
        .catch((error) => {
          console.log(error);
          this.setState({ 'resendResult': '', 'resendError': 'Error Signing in with EmailId, please try again' });
        });
    }
  }


  render() {
    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>VIZFM Signin</title>
          <link rel="canonical" href="https://www.vizfm.com/confirm-userid" />
          <meta name="description" content="VIZFM Userid confirmation Screen" />
        </Helmet>
        <Container fluid className="p-2">
          <Row className="justify-content-md-center">
            <Col xs={12} sm={6} md={6} lg={6} xl={6} xxl={6}>
              <Card style={{ backgroundColor: '#f6f6f6' }}>
                <Card.Body>
                  {(this.state.result !== '') ? (
                    <Alert key='primary' variant='success'>
                      Your emailid has been confirmed, now please {' '}
                      <Link to='/signin'>Sign In</Link>
                    </Alert>
                  ) : <></>}
                  {(this.state.error !== '') ? (
                    <>
                      <Alert key='danger' variant='danger'>
                        {this.state.error}
                      </Alert>
                      <Button variant="primary" onClick={this.resendEmailConfirmation}>Resend Email</Button>
                    </>
                  ) : <></>}

                  {(this.state.resendResult !== '') ? (
                    <Alert key='primary' variant='success'>
                      An email has been sent out with the password, please check your email inbox
                    </Alert>
                  ) : <></>}
                  {(this.state.resendError !== '') ? (
                    <>
                      <Alert key='danger' variant='danger'>
                        {this.state.resendError}
                      </Alert>
                    </>
                  ) : <></>}


                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

function ConfirmUserIdWrap(props) {
  let navigate = useNavigate();
  let params = useParams();
  return <ConfirmUserIdWithParams {...params} {...props} navigate={navigate} />
}

export default ConfirmUserIdWrap;
